<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div class="form-content">
      <div class="form-content-title">
        <div class="form-content-title-block form-title">
          <div class="form-title-block form-title-principal">
            <span>Subpartida</span>
          </div>

          <div
            class="form-title-block"
            v-if="$store.state.user.attributes.permissions_keys.includes(8)"
          >
            <button class="btn btn-primary" @click="openModal('nueva-subpartida')">
              <i class="fas fa-plus"></i>
              Nueva Subpartida
            </button>
          </div>
        </div>
      </div>

      <div class="table-paquete">
        <data-table
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
          v-if="is_loading == false"
        >
          <section class="u-table p-4">
            <div class="u-row-sub u-row--header">
              <h4 class="u-row__title">ID</h4>
              <h4 class="u-row__title">Name</h4>
              <h4 class="u-row__title">Ad_Valorem</h4>
              <h4 class="u-row__title">ISC</h4>
              <h4 class="u-row__title">IGV</h4>
              <h4 class="u-row__title">IPM</h4>
              <h4 class="u-row__title">Seguro</h4>
              <h4 class="u-row__title">Sobretasa</h4>
              <h4 class="u-row__title">Unit</h4>
            </div>

            <div
              class="u-row-sub align-items-center"
              v-for="data in subPartidaList"
              :key="data"
            >
              <p class="sub-content">{{ data.id }}</p>
              <p class="sub-content">{{ data.name }}</p>
              <p class="sub-content">{{ data.ad_valorem }}</p>
              <p class="sub-content">{{ data.isc }}</p>
              <p class="sub-content">{{ data.igv }}</p>
              <p class="sub-content">{{ data.ipm }}</p>
              <p class="sub-content">{{ data.seguro }}</p>
              <p class="sub-content">{{ data.sobretasa }}</p>
              <p class="sub-content">{{ data.unit }}</p>
              <div>
                <button
                  class="btn btn-success mb-2"
                  @click="openModal('editar-subpartida', data)"
                >
                  Editar
                </button>
                <!-- @click="openModal('confirm-delete')" -->
                <button class="btn btn-danger" @click.prevent="deleteSubPartida(data.id)">
                  Eliminar
                </button>
              </div>
            </div>
          </section>
        </data-table>
      </div>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getSubPartidas"
      v-if="is_loading == false"
    ></pagination>

    <dialog id="nueva-subpartida">
      <article class="u-modal">
        <form @submit.prevent="createSubPartida" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Nueva subpartida</span>
            <span style="cursor: pointer" @click="closeModal('nueva-subpartida')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>

          <div class="form-group">
            <label>Nombre</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.name"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4 pl-0">
              <label>Ad_valorem</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.ad_valorem"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-4">
              <label>ISC</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.isc"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-4 pr-0">
              <label>IGV</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.igv"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>IPM</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.ipm"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Seguro</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.seguro"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Sobretasa</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.sobretasa"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Unit</label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.unit"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar subpartida
          </button>
        </form>
      </article>
    </dialog>
    <dialog id="editar-subpartida">
      <article class="u-modal">
        <form @submit.prevent="EditSubPartida" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Editar subpartida</span>
            <span style="cursor: pointer" @click="closeModal('editar-subpartida')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>

          <div class="form-group">
            <label>Nombre</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.name"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4 pl-0">
              <label>Ad_valorem</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="formCreate.ad_valorem"
                  step="any"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-4">
              <label>ISC</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.isc"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-4 pr-0">
              <label>IGV</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.igv"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>IPM</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.ipm"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Seguro</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.seguro"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Sobretasa</label>
              <div class="input-group">
                <input
                  type="number"
                  step="any"
                  v-model="formCreate.sobretasa"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Unit</label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.unit"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>

          <button
            @click.prevent="createSubPartida"
            type="submit"
            class="btn btn-primary mx-auto d-block mt-4"
          >
            Editar subpartida
          </button>
        </form>
      </article>
    </dialog>

    <dialog id="confirm-delete">
      <article class="u-modal">
        <form @submit.prevent="" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-end">
            <span style="cursor: pointer" @click="closeModal('confirm-delete')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <h5 class="px-4 mt-3 mb-4">¿Seguro que desas eliminar esta subpartida?</h5>
          <div class="row justify-content-center">
            <button class="btn btn-danger mr-1" @click="closeModal('confirm-delete')">
              Eliminar
            </button>
            <button class="btn btn-info ml-1" @click="closeModal('confirm-delete')">
              Cancelar
            </button>
          </div>
        </form>
      </article>
    </dialog>
  </div>
</template>
<style>
.table tr {
  border: none;
}
.u-table {
}

.u-row-sub {
  display: grid;
  align-items: start;
  grid-template-columns: repeat(10, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.u-row--header {
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #ccc;
}

.u-row__title {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.65;
}

.sub-content {
  margin: 0;
  font-weight: 500;
}
</style>
<script>
import { Glide, GlideSlide } from "vue-glide-js";

import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import DataTable from "./DataTable.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: {
    DataTable,
    Pagination,
    breadcrumb,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    let statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado",
    };
    // eslint-disable-next-line no-unused-vars
    let statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado",
    };
    // eslint-disable-next-line no-unused-vars
    let cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking",
    };
    let sortOrders = {};
    let columns = [
      { label: "Producto", name: "product", visible: false },
      { label: "Consignatario", name: "consignatario", visible: false },
      { label: "Acciones", name: "acciones", visible: false },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,
      //almacena todos los paquetes
      warehouseorder: null,
      //Formulario para crear un paquete
      formCreate: {
        id: null,
        name: null,
        ad_valorem: null,
        isc: null,
        igv: null,
        ipm: null,
        seguro: null,
        sobretasa: null,
        unit: null,
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns,
      statusGroupArray,
      statusArray,
      cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true,
        }, // 0: Inicializando, 1: En proceso, 2: Cancelado, 3: Finalizado
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5, // órdenes de Grabr y no Grabr
        store: "all",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      grabr: {
        id: "1",
      },
      is_loading: true,
      nameSection: "Subpartida",
      listRoutes: [{ nameRoute: "Subpartida", titleRoute: "Subpartida" }],
      subPartidaList: [],
    };
  },
  created() {
    this.getSubPartidas();
  },
  methods: {
    deleteSubPartida(id) {
      var answer = window.confirm("Seguro de eliminar la SubPartida:" + id);
      if (answer) {
        this.is_loading = true;

        let url = process.env.API_URL + "/api/subpartida/deleteSubpartida/" + id;
        axios
          .delete(url)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Error al eliminar el SubPartida");
            this.is_loading = false;
          });
      }
    },
    //dev marco ->create paquete//
    createSubPartida() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/subpartida/createSubpartidas";
      axios
        .post(url, this.formCreate)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al crear el SubPartida");
          this.is_loading = false;
        });
    },
    EditSubPartida() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/subpartida/createSubpartidas";
      axios
        .post(url, this.formCreate)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al editar  SubPartida");
          this.is_loading = false;
        });
    },
    getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado() {
      this.valorRadioButton = false;
    },

    toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      let linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getSubPartidas(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;
      let url = process.env.API_URL + "/api/subpartida/getSubpartidas";
      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.subPartidaList = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    getPurchaseOrdersByPage(page = 1) {
      // 1: Ver todas las órdenes de compra,
      // 2: Ver todas las órdenes de compra por operador
      // 3: Ver todas las órdenes de compra por cliente
      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      let permissions = this.$store.state.user.attributes.permissions_keys;
      let url = "";
      if (permissions.includes(1)) {
        url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-client";
      } else {
        // alert('El usuario no tiene permisos para ver órdenes de compra')
        return;
      }
      this.tableData.status = this.statusComputed;

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          let data = response.data;

          if (this.tableData.draw === data.meta.draw) {
            console.log("RESPONSE:");

            console.log("there are sync");
            console.log("Table data : ");
            console.log(this.tableData);
            console.log(data);

            console.log("=======================");

            this.purchaseOrders = data.data;
            this.configPagination(data);
            this.is_loading = false;
            console.log("FIN RESPONSE");
          } else {
            console.log("ERROR:");

            console.log("out of sync");

            console.log(this.tableData);
            this.is_loading = false;
            console.log("FIN ERROR");
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.purchaseOrders = null;
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir,
        this.sortOrders[key]
      );
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir
      );
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    hideModal() {
      this.$refs.formmodal.hide();
    },

    openModal(id, data) {
      if (data) {
        this.formCreate.id = data.id;
        this.formCreate.name = data.name;
        this.formCreate.ad_valorem = data.ad_valorem;
        this.formCreate.isc = data.isc;
        this.formCreate.igv = data.igv;
        this.formCreate.ipm = data.ipm;
        this.formCreate.seguro = data.seguro;
        this.formCreate.sobretasa = data.sobretasa;
        this.formCreate.unit = data.unit;
      }

      const modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal(id) {
      const modal = document.getElementById(id);
      modal.close();
      this.formCreate.id = null;
      this.formCreate.name = null;
      this.formCreate.ad_valorem = null;
      this.formCreate.isc = null;
      this.formCreate.igv = null;
      this.formCreate.ipm = null;
      this.formCreate.seguro = null;
      this.formCreate.sobretasa = null;
      this.formCreate.unit = null;
    },
    prevSlide() {
      this.currentSlide === 1
        ? (this.currentSlide = this.maxSlide)
        : (this.currentSlide = this.currentSlide - 1);
    },
    nextSlide() {
      this.currentSlide === this.maxSlide
        ? (this.currentSlide = 1)
        : (this.currentSlide = this.currentSlide + 1);
    },
  },
  computed: {
    diasRestantes() {
      let fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach((data) => {
        let fechaEntrega = data.attributes.promised_delivery_date;
        let fecha = new Date();
        let fechaini = new Date(fechaEntrega);
        let diff = fechaini.getTime() - fecha.getTime();
        let diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns() {
      // let activeFilterColumns = [
      //   "product_info",
      //   "destination",
      //   "order_code",
      //   "tracking_number",
      //   "grabr_code",
      //   "client_name",
      //   "client_dni",
      //   "client_grabr_id",
      //   "id",
      // ];

      let activeFilterColumns = [
        "product_info",
        "referent link",
        "order_code",
        "client_grabr_id",
        "destination",
        "tracking_number",
      ];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
    statusComputed() {
      console.log("statuscomputed");
      return JSON.stringify([
        this.tableData.statusFlag.todos,
        this.tableData.statusFlag.activos,
        this.tableData.statusFlag.cancelados,
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// SubpartidaTable.vue?d1943a5a